import { animate, state, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, ElementRef } from '@angular/core';

const KEY_ENTER = 'Enter';
const KEY_ESCAPE = 'Escape';

@Component({
  selector: 'app-imageViewer',
  templateUrl: './imageViewer.component.html',
  styleUrls: ['./imageViewer.component.scss'],
  animations: [
    trigger('windowState', [
      state('inactive', style({ opacity: 0, top: '1vh', display: 'none' })),
      state('active', style({ opacity: 1, top: '60px', display: 'box' })),
      transition('inactive => active', animate('250ms ease-in')),
      transition('active => inactive', animate('250ms ease-out'))
    ]),
    trigger('backgroundState', [
      state('inactive', style({ opacity: 0, display: 'none' })),
      state('active', style({ opacity: 1, display: 'box' })),
      transition('inactive => active', animate('250ms ease-in')),
      transition('active => inactive', animate('250ms ease-out'))
    ])
  ]
})
export class ImageViewerComponent implements AfterViewInit {
  public state = 'inactive';

  constructor(public element: ElementRef) {}

  public ngAfterViewInit() {
    document.addEventListener('keyup', this.keyUp.bind(this));
  }

  public show() {
    this.state = 'active';
  }

  public hide() {
    this.state = 'inactive';
  }

  private isActive(): boolean {
    return this.state === 'active';
  }

  private keyUp(event: any) {
    if (this.isActive()) {
      if (event.key === KEY_ENTER || event.key === KEY_ESCAPE) {
        this.hide();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/imageViewer/imageViewer.component.ts